import request from '@/utils/axios';

// 资源域名nacos配置
export const getNacosConfig = () => {
    return request.get('/base/common_api/pc')
};
